// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GXehW","title":"styles_title__fBpRJ","formContainer":"styles_formContainer__3mv-B","right":"styles_right__snfLb","left":"styles_left__4yptQ"};